import { isGlobalFeatureEnabled } from "owa-feature-flags";
import { getConfig } from "owa-service/lib/config";

export default function isNestedAppAuthAvailable(): boolean {
    return ((isGlobalFeatureEnabled("auth-naa-native") || isGlobalFeatureEnabled("auth-naa-web")) &&
        !!getConfig().executeNaaRequest);
}
